/* Layer-haus theme scripts */
(function () {
  'use strict';

  // --- mobile nav ---------------------------------------------------------
  var nav = document.getElementById('site-nav');
  var open = document.getElementById('nav-open');
  var close = document.getElementById('nav-close');
  if (open && nav) open.addEventListener('click', function () { nav.classList.add('is-open'); });
  if (close && nav) close.addEventListener('click', function () { nav.classList.remove('is-open'); });
  if (nav) {
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('is-open'); });
    });
  }

  // --- sticky header + scroll top ----------------------------------------
  var header = document.querySelector('.header');
  var top = document.getElementById('scroll-top');
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (header) header.classList.toggle('is-scrolled', y >= 50);
    if (top) top.classList.toggle('is-visible', y >= 400);
  });

  // --- theme toggle -------------------------------------------------------
  var themeBtn = document.getElementById('theme-toggle');
  if (themeBtn) {
    var syncIcon = function () {
      var dark = document.documentElement.classList.contains('dark-theme');
      var icon = themeBtn.querySelector('i');
      if (icon) icon.className = dark ? 'fa-solid fa-sun' : 'fa-solid fa-moon';
    };
    syncIcon();
    themeBtn.addEventListener('click', function () {
      document.documentElement.classList.toggle('dark-theme');
      try {
        localStorage.setItem('selected-theme',
          document.documentElement.classList.contains('dark-theme') ? 'dark' : 'light');
      } catch (e) {}
      syncIcon();
    });
  }

  // --- variant picker on the product page --------------------------------
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var scope = select.closest('[data-product-root]') || document;
      var priceEl = scope.querySelector('[data-product-price]');
      var imgEl = scope.querySelector('[data-product-image]');
      var btn = scope.querySelector('[data-add-button]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (imgEl && opt.dataset.image) imgEl.setAttribute('src', opt.dataset.image);
      if (btn) {
        var sold = opt.dataset.available === 'false';
        btn.disabled = sold;
        btn.textContent = sold ? 'Sold out' : btn.dataset.label;
      }
    });
  });

  // product thumbnails
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-product-image]');
      if (main) main.setAttribute('src', thumb.dataset.thumb);
    });
  });

  // --- reveal on scroll ---------------------------------------------------
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach(function (el, i) {
      el.style.transitionDelay = (i % 3) * 0.1 + 's';
      io.observe(el);
    });
  } else {
    items.forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
